/*
 * -----------------------------------------------------------------------------
 *  Lucom Interaction Platform
 *  (C) Lucom GmbH, Erkrath. All rights reserved.
 * -----------------------------------------------------------------------------
 */

import Axios from "axios";
import Logger from "./Logger";

const log = new Logger(import.meta.url);

export default class Network {
    static create(baseURL: string, ajaxRequestHeaders: any) {
        const instance = Axios.create({
            baseURL,
            withCredentials: true,
            headers: {
                Accept: "application/json",
                ...ajaxRequestHeaders,
            },
        });

        instance.interceptors.response.use(
            (response) => response,
            (error) => {
                let message = `network error: ${error.message}`;
                if (error.response) {
                    if (error.response.status) message += `, code: ${error.response.status}`;
                    // disabled because it exposes too much information (HTML code from tomcat, e.g. when trying to fetch a non-existing image) - maybe check for mime-type and prevent display when html, and/or only include data when developmentmode (not easy to detect at this place)
                    //					if (error.response.data) {
                    //						let json = JSON.stringify (error.response.data);
                    //						if (json !== "{}")
                    //							message += `, data: ${json}`;
                    //					}
                }
                log.error(message);
                return Promise.reject(error);
            }
        );

        return instance;
    }
}
